import React           from 'react';
import WizardFormStore from '@widesk-ui/stores/WizardFormStore';

type WizardFormContextType = { wizardFormStore?: WizardFormStore; }

const WizardFormContext = React.createContext<WizardFormContextType>({ wizardFormStore: undefined });

export default WizardFormContext;
